export default __webpack_public_path__ + "TTHoves-Regular.woff2";